import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';

import {
  editCrashCourseBatchModalStateSelector,
  setEditCrashCourseBatchModalState,
} from 'features/classCreation';
import ConfirmModalContent from '../ConfirmModalContent';

function ConfirmModal() {
  const dispatch = useDispatch();
  const isOpen = useSelector(editCrashCourseBatchModalStateSelector);

  const handleModalClose = useCallback(() => {
    dispatch(setEditCrashCourseBatchModalState(false));
  }, [dispatch]);

  return (
    <Modal
      isOpen={isOpen}
      withoutHeader
      onClose={handleModalClose}
      unMountOnClose
      className="p-s"
      size="large"
    >
      <ConfirmModalContent />
    </Modal>
  );
}

export default ConfirmModal;
